import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '@app/core/Services';

@Component({
  selector: 'app-additionals-accounting-policy-popup',
  templateUrl: './additionals-accounting-policy-popup.component.html',
  styleUrls: ['./additionals-accounting-policy-popup.component.scss']
})
export class AdditionalsAccountingPolicyPopupComponent implements OnInit {

  form : FormGroup;
  
  constructor(
    public dialogRef: MatDialogRef<AdditionalsAccountingPolicyPopupComponent>,
    public commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.setForm();
  }

  onCloseClick() : void {
    this.dialogRef.close(false);
  }

  setForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', [
        Validators.required,
      ]),
      noteContents: new FormControl('', [
        Validators.required
      ]),
    });
  }
  
}
